/**We need to consider the following different variations of the PO BOX keywords:

P O Box, P.O Box, P . O Box, P.O. Box,  POST BOX, POSTBOX, LOCK BOX, LOCKBOX */
const POBoxVariations = ['pobox', 'lockbox', 'postbox'];
export function checkIsPostBox(input: string) {
  let lowerCaseInput = input?.toLowerCase() || '';
  lowerCaseInput = lowerCaseInput.replace(/[ .]/g, '');
  return POBoxVariations.some((v) => lowerCaseInput.includes(v));
}
